import { cva } from 'cva';
export const badgeVariants = cva({
    base: ['@text-grey-1'],
    variants: {
        variant: {
            dot: [],
            sup: [
                '@mt-[-1em]',
                '@ml-[-3px]',
                '@mr-[-1px]',
            ],
            num: [
                '@ml-1',
                '@text-num12',
                '!@leading-4',
                '@min-w-4',
                '@px-1',
                '@rounded-full',
            ],
            icon: [
                '@leading-[0]',
                '[&>svg]:@w-3',
                '[&>svg]:@h-3',
                '@p-0.5',
                '@ml-1',
                '@rounded',
            ],
        },
    },
    compoundVariants: [
        {
            variant: ['dot', 'sup'],
            class: [
                '@w-2',
                '@h-2',
                '@rounded-full',
                '@border',
                '@border-grey-0',
            ]
        }
    ],
    defaultVariants: { variant: 'dot' },
});
